import PropTypes from "prop-types"
import { Row, Col, Collapse } from "antd"
import { Text } from "ui/Typography"
import { numberToCurrency } from "helpers/string"
import { useTranslation } from "react-i18next"

const SummaryKeyValue = ({ details, valueAlign }) => {
  const { t } = useTranslation()
  if (!Array.isArray(details) || details.length === 0) return null
  const isAlignRight = valueAlign === "right"
  return details
    .filter(({ value }) => value !== undefined && value !== null && value !== "")
    .map(({ label, labelKey, count, value, fw, info, isDiscount }, idx) => {
      const labelText = labelKey ? t(labelKey, { count }) : label
      const textType = isDiscount ? "danger" : undefined

      if (info?.length > 0) {
        return (
          <Collapse
            key={(labelKey || label || "item") + idx}
            ghost
            items={[
              {
                key: "tax-fees",
                styles: {
                  header: { padding: 0 },
                  body: { padding: "4px 0 0 16px" }
                },
                label: (
                  <Row gutter={[0, 0]}>
                    <Col xs={14} md={12}>
                      <Text fw={fw || 400}>{labelText}</Text>
                    </Col>
                    <Col xs={10} md={12} style={{ textAlign: isAlignRight ? "right" : "left" }}>
                      <Text fw={fw || 500}>
                        {isAlignRight ? "" : "\u00A0\u00A0"}
                        {numberToCurrency(value)}
                      </Text>
                    </Col>
                  </Row>
                ),
                children: info.map((child, childIdx) => (
                  <Row key={child.label + childIdx} gutter={[0, 0]} style={{ marginTop: 4 }}>
                    <Col xs={14} md={12}>
                      <Text type="secondary">{child.label}</Text>
                    </Col>
                    <Col xs={10} md={12} style={{ textAlign: isAlignRight ? "right" : "left" }}>
                      <Text type="secondary">
                        {isAlignRight ? "" : "\u00A0\u00A0"}
                        {child.amount}
                      </Text>
                    </Col>
                  </Row>
                ))
              }
            ]}
          />
        )
      }

      return (
        <Row key={(labelKey || label || "item") + idx} gutter={[0, 0]}>
          <Col xs={14} md={12}>
            <Text fw={fw || 400} type={textType}>{labelText}</Text>
          </Col>
          <Col xs={10} md={12} style={{ textAlign: isAlignRight ? "right" : "left" }}>
            <Text fw={fw || 500} type={textType}>
              {isAlignRight ? "" : "\u00A0\u00A0"}
              {numberToCurrency(value)}
            </Text>
          </Col>
        </Row>
      )
    })
}

SummaryKeyValue.propTypes = {
  details: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      labelKey: PropTypes.string,
      count: PropTypes.number,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      fw: PropTypes.number,
      isDiscount: PropTypes.bool
    })
  ),
  valueAlign: PropTypes.oneOf(["left", "right"])
}

export default SummaryKeyValue
